import { Select, Form } from 'antd';
import React from 'react';
import './style.css';

/**
 * Represents an option in the select dropdown.
 */
interface Option {
  /** The value of the option. */
  value: string | number;
  /** The label displayed for the option. */
  label: string;
}

/**
 * Props for the SelectionWithLabel component.
 */
interface SelectionWithLabelProps {
  /** Label text displayed above the select dropdown. */
  label: string;
  /** Array of options to be displayed in the select dropdown. */
  options: Option[];
  /** Name of the form field. */
  name: string | string[];
  /** Placeholder text for the select dropdown. */
  placeholder?: string;

  /** Callback function triggered when the selected value changes. */
  onChange?: (value: string | number) => void;
}

/**
 * A selection dropdown with a label using Ant Design's Select component.
 *
 * @param {SelectionWithLabelProps} props - The component props.
 * @returns {JSX.Element} The rendered SelectionWithLabel component.
 */
const SelectionWithLabel: React.FC<SelectionWithLabelProps> = ({ label, options, name, placeholder, onChange }) => {
  return (
    <div id="selectionWrapper" className="selectionWrapper">
      <div className="selectionLabel">{label}</div>
      <div className="selectionElement">
        <Form.Item style={{ width: '100%', marginBottom: '0px' }} name={name}>
          <Select
            placeholder={placeholder}
            variant="filled"
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              background: '#F5F5F5',
              border: 'none',
              borderRadius: '4px',
            }}
            options={options}
            onChange={onChange}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default SelectionWithLabel;
